export enum IconClassType {
	Light = 'light',
	Dark = 'dark',
	White = 'white',
	Yellow = 'yellow'
}
